<template>
  <div id="fixed-header-nav-new" class="flex-column">
    <div id="fixed-header-nav-new-main" class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <h1 id="fixed-header-nav-new-txt" class="mr-2">
          {{ title }}
          <span v-if="records" class="badge">({{ records }} records)</span>
        </h1>
        <slot name="left"></slot>
      </div>
      <div class="d-flex align-items-center">
        <slot name="center"></slot>
      </div>
      <div class="d-flex align-items-center">
        <slot></slot>
        <b-button v-if="!hideNewOfferBtn" variant="primary" size="sm" @click="$bvModal.show('global-offer-modal')"> 
          <i class="fa fa-handshake-o"></i> New Offer 
        </b-button>
        <i v-if="!hideBackBtn" id="go-back-naviation-header-link" class=" fa fa-times ml-2" @click="goBackNavigation"></i>
      </div>
    </div>
    <div v-if="subNav" id="fixed-header-nav-new-sub">
      <slot name="subNav"></slot>
    </div>
    <offer-component :modalId="'global-offer-modal'" />
  </div>
</template>

<script>
import OfferComponent from '@/shared/components/Offers/components/AddOffer';

export default {
  components: {
    OfferComponent
  },
  props: {
    title: String,
    records: [Number, String],
    subNav: Boolean,
    hideBackBtn: {
      type: Boolean,
      default: false
    },
    hideNewOfferBtn: {
      type: Boolean,
      default: false
    },
    listPage: {
      type: [String],
      default: ''
    }
  },
  methods: {
    resizeHeaderToContainer() {
      setTimeout(() => {
        const $fixedHeaderNav = document.getElementById('fixed-header-nav-new');
        const $containerFluid = document.getElementsByClassName('container-fluid')[0];

        if($fixedHeaderNav && $containerFluid) {
          $fixedHeaderNav.style.width = $containerFluid.clientWidth + 'px';
        }
      }, 500);
    },
    goBackNavigation() {
      if (this.listPage) {
        this.$router.push({
          path: this.listPage,
        });
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      //Register event
      window.addEventListener('resize', this.resizeHeaderToContainer);

      this.resizeHeaderToContainer();
    });
  },
  beforeDestroy() {
    //Unregister event
    window.removeEventListener('resize', this.resizeHeaderToContainer);
  },
}
</script>

<style>

#fixed-header-nav-new {
    width: 100%;
    /*z-index: 1000;*/
    /*position: relative;*/
    /*top: 55px;*/
    border-bottom: 1px solid rgb(200, 206, 211);
    background: rgba(245, 245, 245, 0.95);
    /*margin: 0px;*/
    padding: 0px 20px;
}

#fixed-header-nav-new-main, #fixed-header-nav-new-sub {
  height: 49px;
}

#fixed-header-nav-new-txt {
  font-size: 20px;
  margin: 0px;
  flex-shrink: 0;
}

#go-back-naviation-header-link {
  font-size: 20px;
  cursor: pointer;
  color: #aaa;
  transition: color 0.3s;
}

#go-back-naviation-header-link:hover {
  color: #555;
}

</style>